// walletMixin.js
export default {
  data() {
    return {
      walletData: null,
      isLoading: true,
      error: null,
    };
  },
  methods: {
    async fetchWalletData() {
      this.isLoading = true;
      this.error = null;

      try {
        const response = await this.$store.dispatch("user/getWalletData");
        this.walletData = response;
        return response;
      } catch (error) {
        console.error("Error fetching wallet data:", error);
        this.error = "Failed to load wallet data. Please try again.";
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
  async created() {
    await this.fetchWalletData();
  },
};
